import { useNavigate } from "react-router-dom";
import { X, ChevronRight } from "lucide-react";

import { fmtDateTime } from "@/lib/datetime";
import { PRIORITY_STYLES, CATEGORY_LABELS } from "@/services/notificationService";

/** A single notification row, reused by the top-bar panel and the full page. */
export const NotificationItem = ({ n, onRead, onDismiss, onAfterNavigate, compact = false }) => {
  const navigate = useNavigate();
  const p = PRIORITY_STYLES[n.priority] || PRIORITY_STYLES.info;
  const unread = !n.read_at;

  const go = async () => {
    if (unread) await onRead?.(n.id);
    if (n.action_route) {
      navigate(n.action_route);
      onAfterNavigate?.();
    }
  };

  return (
    <div
      data-testid="notification-item"
      className={`group relative flex gap-3 border-b border-border px-4 py-3 transition-colors hover:bg-secondary/60 ${unread ? "bg-accent/5" : ""}`}
    >
      <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${p.dot}`} aria-hidden />
      <button onClick={go} className="min-w-0 flex-1 text-left" data-testid="notification-open">
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-bold uppercase tracking-wide text-muted-foreground">{CATEGORY_LABELS[n.category] || n.category}</span>
          <span className={`text-[10px] font-semibold ${p.text}`}>{p.label}</span>
        </div>
        <p className={`mt-0.5 truncate text-sm ${unread ? "font-semibold text-foreground" : "font-medium text-foreground/90"}`}>{n.title}</p>
        <p className="truncate text-xs text-muted-foreground">{n.message}</p>
        {!compact && <p className="mt-1 text-[10px] text-muted-foreground">{fmtDateTime(n.created_at)}</p>}
        {n.action_label && (
          <span className="mt-1 inline-flex items-center gap-0.5 text-xs font-medium text-accent">{n.action_label} <ChevronRight className="h-3 w-3" /></span>
        )}
      </button>
      <button
        onClick={() => onDismiss?.(n.id)}
        data-testid="notification-dismiss"
        aria-label="Dismiss notification"
        className="absolute right-2 top-2 rounded p-1 text-muted-foreground opacity-0 transition-opacity hover:bg-secondary hover:text-foreground group-hover:opacity-100"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
